import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { SettingsWrapperControl } from './settings-wrapper-control';
import { IDesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';

const displayControlTemplate = `<tr><td style="margin-top:2px;margin-bottom:2px;padding-top:2px;padding-bottom:2px;border-top:2px solid transparent;border-bottom:2px solid transparent;width:100%"></td></tr>`;
const settingsControlTemplate = ``;

export class TableRowControl implements IDesignControl {
  id: string;
  parentElement: HTMLElement;
  controlElement: HTMLElement;
  controlTemplate: string = displayControlTemplate;
  settingsTemplate: string = settingsControlTemplate;
  controlType: TemplateControlType.TableRow;
  editControl: SettingsWrapperControl;
  templateControlService: TemplateControlService;
  document: Document;
  canEdit = true;
  canCopy = true;
  canDelete = true;

  public get childContentElement(): HTMLElement {
    return this.controlElement.firstElementChild as HTMLElement;
  }

  constructor(document: Document, templateControlService: TemplateControlService) {
    this.document = document;
    this.templateControlService = templateControlService;
  }

  public appendControl(parentElement: HTMLElement): void {
    const container = document.createElement('template');
    container.innerHTML = this.controlTemplate;
    this.controlElement = container.content.firstElementChild as HTMLElement;

    parentElement.appendChild(this.controlElement);
    this.controlElement.style.zIndex = '10';

    this.writeDataAttributeValues();
  }

  public insertSiblingControl(siblingElement: HTMLElement) {
    const container = document.createElement('template');
    container.innerHTML = this.controlTemplate;
    this.controlElement = container.content.firstElementChild as HTMLElement;

    siblingElement.insertAdjacentElement('afterend', this.controlElement);
    this.controlElement.style.zIndex = '10';

    this.writeDataAttributeValues();
  }

  public writeDataAttributeValues() {
    this.controlElement.id = this.id;
    this.controlElement.setAttribute('id', this.id);
    this.controlElement.setAttribute('data-id', this.id);
    this.controlElement.setAttribute('data-control-type', TemplateControlType[this.controlType]);
  }

  public wireUpEvents(): void {}
  public edit(): void {}
  public cancel(): void {}
  public save(): void {}
  public copy(): void {}
  public destroy(): void {
    this.controlElement.remove();
  }
  public dragEnter(event: any): void {}
  public dragLeave(event: any): void {}
  public drop(event): void {}
}
